import React from 'react';

import {
  IconButton,
  makeStyles,
  Typography,
  ContentCopyIcon,
} from '@gogame/components';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flex: 1,
    paddingRight: '10px',
  },
  name: {
    wordBreak: 'break-all',
    color: 'inherit!important',
    paddingRight: '10px',
  },
  icon: {
    marginTop: -10,
  },
}));

export const GGLink = ({ value, onCopy }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Typography className={classes.name} style={{ overflow: 'hidden' }}>
        {value}
      </Typography>
      <IconButton
        icon={<ContentCopyIcon />}
        className={classes.icon}
        tooltip={'Copy link'}
        onClick={() => {
          onCopy(value);
        }}
      />
    </div>
  );
};
